"use client";

import React from "react";
import { ArrowRight, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AboutDigitalBridge() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="244487" id="supplier-portal-overview" className="relative overflow-hidden bg-background py-20 lg:py-32">
      {}
      <div className="absolute inset-0 -z-10 bg-[radial-gradient(ellipse_at_top_right,_var(--color-accent)_0%,_transparent_50%)] opacity-5"></div>
      <div className="absolute inset-0 -z-10 bg-[radial-gradient(ellipse_at_bottom_left,_var(--color-primary)_0%,_transparent_50%)] opacity-5"></div>

      <div className="page-container">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-2 lg:gap-16">
          {}
          <div ref={ref} className={`flex flex-col items-start gap-6 transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
            <Badge variant="secondary" className="rounded-sm bg-secondary-light px-4 py-1.5 text-sm font-display font-medium text-secondary">
              Supplier Network
            </Badge>
            
            <h1 className="font-default text-4xl font-bold leading-tight tracking-tight text-foreground md:text-5xl lg:text-6xl">
              Streamline Your Supply Chain Operations
            </h1>
            
            <p className="font-sans text-lg leading-relaxed text-muted-foreground md:text-xl max-w-[600px]">
              Join our integrated supplier portal to access real-time inventory tracking, automated procurement workflows, and direct communication channels. Empower your business with the tools needed for seamless global trade.
            </p>
            
            <div className="mt-4 flex flex-wrap items-center gap-4">
              <Button asChild size="lg" className="rounded-sm bg-accent hover:bg-accent-hover text-white px-8">
                <Link to="/SupplierPortalPage">
                  Access Portal
                  <ArrowRight className="ml-2 size-4" />
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="rounded-sm border-primary text-primary hover:bg-primary-light px-8">
                <Link to="/ContactPage">
                  Partner With Us
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div className={`relative transition-all duration-1000 delay-200 ease-out ${isVisible ? "translate-x-0 opacity-100" : "translate-x-8 opacity-0"}`}>
            <div className="relative aspect-[4/3] overflow-hidden rounded-sm border border-border/50 shadow-strong lg:aspect-square">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542426/img/supplier_portal_dashboard_preview.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542426/img/supplier_portal_dashboard_preview.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542426/img/supplier_portal_dashboard_preview.png-wvc-sizes" alt="Supplier portal dashboard showing logistics and inventory data" className="h-full w-full object-cover transition-transform duration-700 hover:scale-105" loading="lazy" decoding="async" />
              {}
              <div className="absolute inset-0 bg-gradient-to-tr from-primary/20 to-transparent mix-blend-overlay"></div>
            </div>

            {}
            <div className="absolute -bottom-6 -left-6 hidden animate-bounce rounded-sm border border-border bg-white p-6 shadow-medium md:block" style={{
            animationDuration: '4s'
          }}>
              <div className="flex items-center gap-4">
                <div className="flex size-12 items-center justify-center rounded-sm bg-accent/10 text-accent">
                  <Zap className="size-6" />
                </div>
                <div>
                  <p className="font-default text-xl font-bold text-primary">24/7 Access</p>
                  <p className="font-sans text-sm font-medium text-muted-foreground">Real-time Updates</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}